import React, {useEffect, useState} from "react";
import {Button, Input, Space, Table} from "antd";
import {SearchOutlined} from "@ant-design/icons";

const PermissionTable = ({listData, onDataUpdate, isDisabled}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  useEffect(() => {
    const selectedKeys = listData
      .filter((entry) => entry.checked)
      .map((entry) => entry.permission);
    setSelectedRowKeys(selectedKeys);
  }, [listData]);

  const onSelectChange = (newSelectedRowKeys) => {
    if (isDisabled) {
      return;
    }
    setSelectedRowKeys(newSelectedRowKeys);
    const updatedData = listData.map((item) => ({
      ...item,
      checked: newSelectedRowKeys.includes(item.permission),
    }));
    onDataUpdate(updatedData);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
  };

  const getColumnSearchProps = (dataIndex, placeholder) => ({
    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
      <div style={{padding: 8}}>
        <Input
          placeholder={placeholder}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={confirm}
          style={{marginBottom: 8, display: "block"}}
        />
        <Space>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            style={{marginRight: 8}}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, confirm)}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
          fontSize: "18px",
          fontWeight: "bold",
          textShadow: "0 0 3px rgba(0,0,0,0.3)",
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toLowerCase().includes(value.toLowerCase()),
  });

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: () => ({
      disabled: isDisabled,
    }),
  };

  const columns = [
    {
      title: "Permission List",
      dataIndex: "permission",
      width: 400,
      render: (text, record) => (
        <a style={{textDecoration: record.checked ? "underline" : "none"}}>
          {text}
        </a>
      ),
      ...getColumnSearchProps("permission", "Search permission..."),
    },
    {
      title: "Service",
      dataIndex: "service",
      width: 200,
      ...getColumnSearchProps("service", "Search service..."),
    },
  ];

  return (
    <div>
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={listData}
        rowKey={(record) => record.permission}
        pagination={{pageSizeOptions: [10, 20, 50, 100, 500, 1000]}}
      />
      <p>
        Permission selected{" "}
        <span style={{fontWeight: "bold"}}>{selectedRowKeys.length}</span> of{" "}
        <span style={{fontWeight: "bold"}}>{listData.length}</span>
      </p>
    </div>
  );
};

export default PermissionTable;
